import { createSelector, Selector } from 'reselect'

import { lineInitialValues, LineState } from './line.reducer'

import { SignUpType } from '~/basket/model/lines/signup.model'
import { RootState } from '~/core/store/root.reducer'

type GetLines = Selector<RootState, LineState>

export const getLines: GetLines = (state) => state.line

const getId = (_: RootState, id: string) => id

export const selectAllLinesIds = createSelector(getLines, (lines) => Object.keys(lines))

export const selectLine = createSelector(getLines, getId, (lines, id) => {
  return lines[id]
})

export const selectLines = createSelector(getLines, (lines) => lines)

export const selectNewNumber = createSelector(
  selectLine,
  (line) => line?.newNumber.data?.phoneNumber || '',
)

export const selectIsNewNumberLoading = createSelector(
  selectLine,
  (line) => line?.newNumber.loading,
)

export const selectNewNumberError = createSelector(selectLine, (line) => line?.newNumber.errorCode)

export const selectOperator = createSelector(selectLine, (line) => line?.operator.data)

export const selectOperatorId = createSelector(selectLine, (line) => {
  return { id: line?.operator.data?.id || '' }
})

export const selectIsOperatorLoading = createSelector(selectLine, (line) => line?.operator.loading)

export const selectOperatorError = createSelector(selectLine, (line) => line?.operator.errorCode)

export const selectLineValues = createSelector(
  selectLine,
  (line) => line?.values || lineInitialValues,
)

export const selectLineSignUpType = createSelector(
  selectLine,
  (line) => line?.values?.signUp?.signUpType,
)

export const selectDonorOwner = createSelector(
  selectLineValues,
  (lineValues) => lineValues?.signUp?.donorOwner,
)

export const selectDonowOwnerName = createSelector(selectDonorOwner, (donorOwner) => {
  const docType = donorOwner?.docType

  const nameAndSurname = `${donorOwner?.name} ${donorOwner?.firstName}`

  const fullName = `${nameAndSurname} ${donorOwner?.lastName}`

  switch (docType) {
    case 'NIF':
      return fullName
    case 'NIE':
      return donorOwner?.lastName ? fullName : nameAndSurname
    case 'CIF':
      return donorOwner?.companyName

    default:
      return fullName
  }
})

export const selectLinePhoneNumber = createSelector(selectLine, (line) => {
  return line.values.signUp.signUpType === SignUpType.NEW_LINE
    ? line.newNumber.data?.phoneNumber
    : line.operator.data.id && line.values.signUp.lineNumber
})

export const selectLineIccBalance = createSelector(
  selectLine,
  (line) => line.values.signUp.iccBalance,
)

export const selectLineIccAvailable = createSelector(
  selectLine,
  (line) => line.values.signUp.iccAvailable,
)

export const selectAdditionalLines = createSelector(
  selectLines,
  ({ mainLine, ...additionalLines }) => additionalLines,
)
